import classes from "./StatScreen.module.css"
import { useState, useEffect } from "react";
import "@fontsource/roboto";
import Strings from 'values/Strings';
import CountdownTimer from "../countdownTimer/CountdownTimer";
import Marquee from "react-fast-marquee";
import AnimatedNumber from "animated-number-react";
import IconWithText from "../iconWithText/IconWithText";
import Tooltip from "rc-tooltip";
import QrGenerator from "components/UI/qrCode/qrGenerator/QrGenerator";

import EDRO from "assets/images/AI/EDRO.png"
import School from "assets/images/AI/School.png"
import GazInfo from "assets/images/AI/gazInfo.png"
import GazEnerg from "assets/images/AI/gazEnerg.png"
import Intel from "assets/images/AI/intel.png"
import SurGu from "assets/images/AI/SurGu.png"
import Elastic from "assets/images/AI/Elastic.png"
import Art from "assets/images/AI/artl.png"
import Tech from "assets/images/AI/tech.png"
import Adm from "assets/images/AI/hmao.svg"
import Priority2030 from "assets/images/AI/priority2030.png"
import DSK1 from "assets/images/AI/DSK1.png"
import StudProd from "assets/images/AI/studprof.png"

import InputBlock from "../inputBlock/InputBlock";
import Command from "assets/images/main/command.png"
import PrizePool from "assets/images/main/prizepool.png"
import Rub from "assets/images/main/rub.png"
import OccasionService from "services/OccasionService";
import socketIOClient from 'socket.io-client'
import { useDispatch } from "react-redux";
import { newName } from "redux/slice/titleSlice";
import env from '../../../../package.json'
import { useDeviceType } from "components/hooks/useDeviceType";
import CircularChart from "../circleChart/CircleChart";

const socket = socketIOClient(`${env.nodeHost}`)

const StatScreen = () => {

    const logo = [EDRO, Priority2030, DSK1, StudProd, School, GazInfo, SurGu, Intel, GazEnerg, Elastic, Art, Tech, Adm]
    const device = useDeviceType()

    const [occasionList, setOccasionList] = useState([])
    const [currentOccasion, setCurrentOccasion] = useState({ id: 1 })

    const [occasions, setOccasions] = useState([])

    const [finishTime, setFinishTime] = useState('2024-11-17T12:00:00')
    const [value, setValue] = useState({
        "participant_count_current": 120, "command_count_current": 18, "task_count_current": 10,
        "prize_fund_current": 150, "finish_time": '2024-11-17T12:00:00'
    });

    const [stat, setStat] = useState({ "participant": [{ "status": "школьник", "count": 88 }, { "status": "студент", "count": 169 }], "command": 54 })

    useEffect(() => {
        // Подключение к серверу при монтировании компонента
        try {
            socket.on('connect', () => {
                console.log('Connected to server');
            });

            // Прослушивание обновлений данных
            socket.on('db_change', (data) => {
                if (data) {
                    setValue(data?.latest);

                    if (data.participantStat && Array.isArray(data.participantStat.participant)) {
                        data.participantStat.allParticipant = data.participantStat.participant.reduce((sum, item) => sum + (item.count || 0), 0);
                    } else {
                        data.participantStat = { allParticipant: 0 }; // Устанавливаем значение по умолчанию, если participantStat отсутствует или не является массивом
                    }

                    setStat(data.participantStat);
                } else {
                    // Обработка ситуации, если data отсутствует
                    console.warn('Data is undefined or null');
                }
            });
        } catch (error) {
            console.log('error :', error);
        }

        // Отключение при размонтировании компонента
        return () => {
            socket.off('db_change');
            socket.disconnect();
        };
    }, []);

    const url = "https://digital.edro.su"

    async function changeOcassion(data, index) {
        setCurrentOccasion(occasions[index])
    }

    const dispatch = useDispatch()
    let switcher = false

    useEffect(() => {
        dispatch(newName(Strings.infoTvStatTitle))
        //? getBySocketIO()
        // fetchingOccasion()
        setInterval(() => {
            switcher = !switcher
            if (switcher) {
                setValue(old => ({
                    ...old,
                    "participant_count_current": old?.participant_count_current + 0.000001,
                    "command_count_current": old?.command_count_current + 0.000001,
                    "task_count_current": old?.task_count_current + 0.000001, "prize_fund_current": old?.prize_fund_current + 0.000001,
                }))
            } else {
                setValue(old => ({
                    ...old,
                    "participant_count_current": old?.participant_count_current - 0.000001,
                    "command_count_current": old?.command_count_current - 0.000001,
                    "task_count_current": old?.task_count_current - 0.000001, "prize_fund_current": old?.prize_fund_current + 0.000001,
                }))
            }
        }, 25000)
    }, [])

    const formatValue = value => value.toFixed(0);

    return (
        <div style={{ marginBottom: "10vh" }} className={classes.wrapper}>
            {!Object.keys(currentOccasion).length > 0 && <div className={classes.first__block__style}>
                <div style={{ display: "flex" }}>
                    <div style={{ marginRight: "1vw" }}>
                        <Tooltip placement="top" trigger={'hover'} overlay={<span style={{ fontSize: "0.7vw", fontFamily: "Roboto" }} className={classes.tooltip__style}>В данном поле,<br />Вы выбираете мероприятие,<br />статистика которого<br />будет отражена</span>}>
                            <IconWithText text={"Ивент"}><img src={require("assets/icon/briefcase.jpg")} /></IconWithText>
                        </Tooltip>
                    </div>
                    <InputBlock width={45} readOnly={true} indexStatus={true} onListStatus={true} list={occasionList} value={OccasionService.getTextInputOccasion(currentOccasion, false)} setValue={changeOcassion} ><img src={require("assets/images/arrow.jpg")} /></InputBlock>
                </div>
            </div>}


            {
                Object.values(currentOccasion)?.length > 0 && <div className={classes.main__style__for__block}>
                    <div className={classes.block__title__style}>
                        <div className={classes.ellipse__style}>
                        </div>
                        <h1 className={classes.title__style}>
                            Статистика мероприятия
                        </h1>
                    </div>

                    <div className={classes.block__info__style}>

                        <div className={classes.block__with__info}>
                            <div className={classes.stat__style}>
                                <h5 className={classes.h5__style}>
                                    Количество
                                </h5>
                                <div className={classes.stat__with__icon}>
                                    <div className={classes.anim__style__text}>
                                        <AnimatedNumber
                                            value={value?.participant_count_current ? value.participant_count_current : 0}
                                            formatValue={formatValue}
                                            className={classes.h2__style}
                                        />
                                    </div>
                                    <img src={PrizePool} className={classes.img__style} />
                                </div>
                                <h6 className={classes.h6__style}>
                                    участников
                                </h6>
                            </div>

                            <div className={classes.stat__style}>
                                <h5 className={classes.h5__style}>
                                    Количество
                                </h5>
                                <div className={classes.stat__with__icon}>
                                    <div className={classes.anim__style__text}>
                                        <AnimatedNumber
                                            value={value?.command_count_current ? value.command_count_current : 0}
                                            formatValue={formatValue}
                                            className={classes.h2__style}
                                        />
                                    </div>
                                    <img src={Command} className={classes.img__style} />
                                </div>
                                <h6 className={classes.h6__style}>
                                    команд
                                </h6>
                            </div>

                            <div className={classes.stat__style}>
                                <h5 className={classes.h5__style}>
                                    Количество
                                </h5>
                                <div className={classes.stat__with__icon}>
                                    <div className={classes.anim__style__text}>
                                        <AnimatedNumber
                                            value={value?.task_count_current ? value.task_count_current : 0}
                                            formatValue={formatValue}
                                            className={classes.h2__style}
                                        />
                                    </div>
                                    <img src={Rub} className={classes.img__style} />
                                </div>
                                <h6 className={classes.h6__style}>
                                    кейсов
                                </h6>
                            </div>

                            <div className={classes.stat__style}>
                                <h5 className={classes.h5__style}>
                                    Призовой
                                </h5>
                                <div className={classes.stat__with__icon}>
                                    <div className={classes.anim__style__text}>
                                        <AnimatedNumber
                                            value={value?.prize_fund_current ? value.prize_fund_current : 0}
                                            formatValue={formatValue}
                                            className={classes.h2__style}
                                        />
                                    </div>
                                    <img src={Rub} className={classes.img__style} />
                                </div>
                                <h6 className={classes.h6__style}>
                                    тыс. рублей
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                stat?.command > 0 &&
                <div style={{
                    display: "flex",
                    flexDirection: device === "phone" ? "column" : "row",
                    marginBottom: device === "phone" ? "10vw" : "3vw"
                }}>
                    <div style={{
                        display: "flex", width: "100%",
                        justifyContent: 'center', alignItems: 'center'
                    }}>
                        <CircularChart
                            titleUnderChart="Процент школьников"
                            percentText={`${(stat?.participant[0]?.count / stat?.allParticipant * 100).toFixed(0)}%`}
                            percentChart={(stat?.participant[0]?.count / stat?.allParticipant * 100).toFixed(0)}
                        />
                        <div className={classes.style__second__block}>
                            <div className={classes.scan__qr}>
                                {url && <QrGenerator url={url} />}
                            </div>
                            <CountdownTimer targetDate={finishTime} />
                        </div>
                        <CircularChart
                            titleUnderChart="Процент студентов"
                            percentText={`${(stat?.participant[1]?.count / stat?.allParticipant * 100).toFixed(0)}%`}
                            percentChart={(stat?.participant[1]?.count / stat?.allParticipant * 100).toFixed(0)}
                        />
                    </div>
                </div>
            }
            {
                Object.values(currentOccasion)?.length > 0 &&
                <Marquee speed={80} gradientWidth={"15vw"} gradientColor={"#FFF"} gradient={true}>
                    {logo.map((any, i) => <img key={i} src={any} alt="" style={{
                        margin: '0 4vw',
                        width: "7vw",
                    }} />)}
                </Marquee>
            }
        </div>
    )
}

export default StatScreen